<section class="container-fluid no-padding">
    <breadcrumb></breadcrumb>
</section>
<tabset class="nav nav-tabs admin-tab">
        <tab class="dynamic-tab padding0" heading="{{'ticketing-system.My Dispute Tickets' |translate}}" (select)="selectTab(1)" [active]="activetab==1">
                <my-tickets  isDiputeTicketSearch={{true}}></my-tickets>
        </tab>
        <tab class="dynamic-tab padding0" heading="{{'ticketing-system.My Team Dispute Tickets' |translate}}" (select)="selectTab(2)" [active]="activetab==2">
                <my-team-tickets isDiputeTicketSearch={{true}}></my-team-tickets>
        </tab>
        <tab class="dynamic-tab padding0" *ngFor="let tabz of tabs;let idx=index;" [heading]="tabz.title" [active]="tabz.active" (select)="tabz.active = true;"
        (deselect)="tabz.active = false" [disabled]="tabz.disabled" [removable]="tabz.removable" (removed)="removeTabHandler(tabz)">
        <view-work-ticket *ngIf="tabz.componentName == 'viewticketpage'" isView={{tabz.isView}} ticketId={{tabz.ticketId}} ticketinputvalue={{tabz.title}}></view-work-ticket>
        <!--Show view ticket-->
    </tab>
</tabset>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/dispute-tickets.component.html